import Image, { StaticImageData } from 'next/image';
import { ReactNode } from 'react';
import Typography from '@alltrails/core/components/Typography';
import Heading from '@alltrails/denali/components/Heading';
import styles from './FeatureCard.module.scss';

type PlusFeatureListProps = {
  title: ReactNode;
  description: ReactNode;
  altText: string;
  src: StaticImageData;
};

const FeatureCard = ({ title, description, altText, src }: PlusFeatureListProps) => {
  return (
    <div className={styles.slideContainer}>
      <div className={styles.imageContainer}>
        <Image src={src} alt={altText} className={styles.image} />
      </div>
      <Heading as="h3" className={styles.descriptionTitle} size="400">
        {title}
      </Heading>
      <Typography variant="paragraph200" component="p" className={styles.descriptionBody}>
        {description}
      </Typography>
    </div>
  );
};

export default FeatureCard;
